export default "__VITE_ASSET__CfDB7Idd__"